export const payNoMarketAddress = '0x0000000000000000000000000000000000000000';
